<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-file-pdf"></i> {{ "Previsualizar plantilla" }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div style="height: 700px;">
    <ng2-pdfjs-viewer #pdfViewer [pdfSrc]="pdfSrc"
                      [download]="false"
                      [print]="false"
                      [openFile]="false"
                      [showSpinner]="true"
                      [viewBookmark]="false"
                      id="pdfViewer"
                      aria-label="Embedded PDF"
                      scroll="V"
                      viewerId="documentVisor">
    </ng2-pdfjs-viewer>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger"
            (click)="accept()">
      <i class="fas fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>

